
import { StdResponse, request } from "@/global/config/request";
import { Station, StationItem } from "@/global/interface/archi/station";
import localStore from "@/global/store/local-store";
import qs from "qs";


export function findStationDetailByUuid(uuid: string, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/stations/${uuid}`, {
        params: {
            ...params,
        }
    })
}

export function findStationListByProjectId(projectUuid: string, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/projects/${projectUuid}/stations`, {
        params: {
            ...params,
        }
    })
}

export function addStation(projectUuid: string, data: Station, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/projects/${projectUuid}/stations`, data, {
        params: {
            ...params,
        }
    })
}

export function updateStation(uuid: string, data: Station, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/stations/${uuid}`, data, {
        params: {
            ...params,
            projectId: localStore.projectId,
        }
    })
}

export function updateStationItem(id: number, data: StationItem, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/station-items/${id}`, data, {
        params: {
            ...params,
            projectId: localStore.projectId,
        }
    })
}

export function deleteStationByUuid(uuid: string, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/stations/${uuid}`, {
        params: {
            ...params,
            projectId: localStore.projectId,
        }
    })
}

export function deleteStationByUuidList(uuids: string[], params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/stations`, {
        params: {
            uuids: uuids,
            ...params,
            projectId: localStore.projectId,
        },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

export function deleteStationByProjectId(projectId: string, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/projects/${projectId}/stations`, {
        params: {
            ...params,
        }
    })
}